import React, { useState } from 'react'
import DeletePopUp from '../../ui/PopUp/DeletePopUp/DeletePopUp'
import { deleteBlogMaterial } from '../../api/blog/blogApi'
import { removeLocalMaterial } from '../../api/blog/blogLocalStore'

export default function DeleteBlogMaterialPopUp({ material, closePopUp, onDeleted }) {
  const [error, setError] = useState('')
  const submitDelete = async () => {
    setError('')
    try {
      const result = await deleteBlogMaterial({
        materialId: material.id,
        expectedRevision: material.draftRevision || 0,
      })
      if (!result.ok) throw new Error(result.message || 'Не вдалося видалити матеріал')
      const local = await removeLocalMaterial(material.id)
      if (!local.ok) throw new Error('Не вдалося очистити локальну копію. Спробуйте ще раз.')
      onDeleted(material.id)
    } catch (failure) {
      setError(failure.message)
      throw failure
    }
  }
  return (
    <DeletePopUp
      title="Видалити матеріал"
      warningMessage={
        <>
          Видалити «{material.draft?.title || material.title || 'Без назви'}» разом з усіма фото та медіа? Цю дію
          неможливо скасувати.
          {error ? <span role="alert"> {error}</span> : null}
        </>
      }
      submitTitle="Видалити"
      cancelTitle="Скасувати"
      submitDelete={submitDelete}
      closePopUp={closePopUp}
    />
  )
}
